import classnames from 'classnames';
import HorizontalContainerWrapper from 'pages/NewHome/HorizontalContainerWrapper';

import { BannerWithCTAProps } from './types';

import useStyles from './styles';

const BannerWithCTAFallback = ({ mediaIsLeft }: Partial<BannerWithCTAProps>) => {
  const styles = useStyles({ mediaIsLeft });

  return (
    <HorizontalContainerWrapper className={classnames(styles.root, styles.skeletonRoot)}>
      <i className={classnames('skeleton', styles.subTitle, styles.smallTitleFB)} />
      <i className={classnames('skeleton', styles.title, styles.titleFB)} />
      <div className={classnames(styles.descriptionContainer, styles.descriptionContainerFB)}>
        <i className={classnames('skeleton', styles.description)} />
      </div>
      <i className={classnames('skeleton', styles.media)}>
        <i className={classnames('skeleton')} />
      </i>
    </HorizontalContainerWrapper>
  );
};

export default BannerWithCTAFallback;
